import React from 'react';
import Button from '@/ui/Button/Button';
import styles from './styles.module.scss';

const VolteBanner = ({ item, buttonHide }) => {
  const renderTitleComponent = (
    <h3
      className={styles.title}
      dangerouslySetInnerHTML={{
        __html: item?.name || item?.title,
      }}
    />
  );

  return (
    <div
      className={styles.banner}
      style={{
        backgroundImage: `url("${item?.image}")`,
      }}
      itemScope
      itemType='https://schema.org/Offer'
    >
      <div className={styles.wrapper}>
        <div className={styles.top}>
          {renderTitleComponent}

          {item?.description && (
            <div
              className={styles.description}
              dangerouslySetInnerHTML={{ __html: item?.description }}
            />
          )}
        </div>
        {!buttonHide && item?.button_text && (
          <Button
            size='shortTrapezoid'
            variant='trapezoidWhite'
            href={item?.button_slug || item?.external_link}
            Component={item?.button_slug ? 'router' : 'button'}
          >
            {item?.button_text}
          </Button>
        )}
      </div>
    </div>
  );
};

export default VolteBanner;
